const { toInteger } = require("lodash");

/* IniLocationsMap
--------------------
params:

*****************************
mapElementDOM // DOM ELEMENT
*****************************
the DOM element that will be rendered as the map.

Example: $("#officeMap_pickup")[0]

*******************
locations // ARRAY
*******************
a collection of key => value information that will be used to render the markers (latitude, longitude and icon option)

Example: [
    0 => {
        Brand: "AVIS"
        Latitude: "28.43826"
        Longitude: "-81.31076"
    },
    1 => {...}
]

****************
zoom // INTEGER
****************
used when we need to force the zoom for some reason. Usually used only on single location.
zoom goes from 1 to 23, 1 being the most zoom out map.

Example: 14

*/

function initLocationsMap(mapElementDOM, locations, zoom = false, calc_zoom = true) {
    /* bounds is used to automatically set the zoom. the "bounds" will be "extended" for each location.*/
    let bounds = new google.maps.LatLngBounds();

    const map = new google.maps.Map(mapElementDOM, {
        /*  styles recibes a collection of object to define what to show and how.
            featureType is eliminating any business poi (points of interest) on the map*/
        styles: [
            {featureType: "poi.business",
            elementType: "labels",
            stylers:[{visibility: "off"}]}
            // {stylers: [{saturation: -100}]},
        ],
        /*  streetViewControl controls the posibility to change to street view */
        streetViewControl: false,
        /*  mapTypeControl controls the posibility to change the type of maps:
            like maps with setoff or satellite images */
        mapTypeControl: false,
        /*  mapTypeId controls witch map will be used:
            like roadmap, satellite, hybrid, terrain  */
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    addMarkers(locations, map, bounds, mapElementDOM);

    /*  the listener will fit the zoom on map asynchronously whenever the map is done loading.
        fitBounds recives the extended bounds for each marker and will set the zoom accordingly.

        If the zoom is too close or too far will set the zoom to a middle point.
        This is needed becaused if there is only one location to be rendered as marker the zoom will be 22 (too close)
        On the otherhand if there is very distant markers the zoom will be too far away (this should almost never be used)

        Finally, if there is "forced" zoom value for whatever reason... will be set here.

        Also the listener will be created and, whenever is done setting the zoom, destroyed.*/

        let listener = google.maps.event.addListener(map, "idle",
        function () {

            map.fitBounds(bounds);
            if (calc_zoom) {
                if (map.getZoom() > 17) {
                    map.setZoom(17);
                }
                if (map.getZoom() < 15) {
                    map.setZoom(15);
                }

                if (zoom) {
                    map.setZoom(toInteger(zoom));
                }
            }

            if (map.getZoom() > 15) {
                map.setZoom(15);
            }

            google.maps.event.removeListener(listener);
        }
    );

}


/* addMarkers
--------------------
params:

*******************
locations // ARRAY
*******************
a collection of key => value information that will be used to render the markers (latitude, longitude and icon option)

Example: [
    0 => {
        Brand: "AVIS"
        Latitude: "28.43826"
        Longitude: "-81.31076"
    },
    1 => {...}
]

*****************************
bounds // Object google.maps.LatLngBounds
*****************************
The bounds will be extended for each locations latitude and longitude.

Imagined there is one marker(location) that has a position(latitude, longitude) of 752, 156
And the second one has a position 635, 415
The bounds will be set always with four point: the most western and eastern and most southern and notherly
In this case will be { hi: 752, lo: 635 }, {hi: 415, lo: 156}

Example: {
    Ra: {
        hi: -81.30792
        lo: -81.31076
    },
    vb: {
        hi: 28.43826
        lo: 28.431025
    }
}

*****************************
mapElementDOM // DOM ELEMENT
*****************************
the DOM element will be used to limit the click listeners created.

Example: $("#officeMap_pickup")[0]
*/

function addMarkers(locations, map, bounds, mapElementDOM) {
    /* addMarkers will check the BRAND attribute on the locations and set the correct path
       to render the markers icons */
    let svg;
    let root = window.location.origin;

    for (let i = 0; i < locations.length; i++) {
        switch (locations[i]['Brand']) {
            case "AVIS":
                svg = `${root}/dist/images/markers/avisMarker.svg`;
                break;
            case "BUDGET":
                svg = `${root}/dist/images/markers/budgetMarker.svg`;
                break;
            case "PAYLESS":
                svg = `${root}/dist/images/markers/paylessMarker.svg`;
                break;
            default:
                break;
        }

        /*  the marker will used the svg (with specified parameters of size and anchor point for this specifically svg icons)
            will use the latitude and longitude on the location for its position and set up the zIndex */
        const marker = new google.maps.Marker({
            icon: {
                anchor: new google.maps.Point(44, 48),
                size: new google.maps.Size(90, 57),
                url: svg,
            },
            id: locations[i]['Brand'],
            fullCode: locations[i]['fullcode'],
            position: new google.maps.LatLng(locations[i]['Latitude'], locations[i]['Longitude']),
            map: map,
            zIndex: 10 - i,
        });

        /*  This will check and extend the values of the bounds for each location
            as previously mention on the summary  */
        bounds.extend(marker.position);

        /*  If there is more than one marker, in this case, it means that there will be a tab/nav
            navigation element also. This will simulate a click to header elements to navigate clicking on the markers */
        if (locations.length > 1) {
            marker.addListener('click', function () {

                // console.log($(mapElementDOM.offsetParent).find(`[data-full-code="${marker.fullCode}"]`)[0]);
                let officeSelected = $(mapElementDOM.offsetParent).find(`[data-full-code="${marker.fullCode}"]`)[0];
                let canvasScrollOffices = $(mapElementDOM.offsetParent).find('.scroll-custom-offices')[0];

                // console.log(marker.fullCode);
                if (officeSelected && canvasScrollOffices) {
                    let scrollTo = officeSelected.offsetTop - officeSelected.clientHeight - 100;

                    canvasScrollOffices.scrollTo({
                        top: scrollTo,
                        behavior: 'smooth'
                    });
                }

                // $(mapElementDOM.offsetParent).find(`#header_office_${marker.id}`)[0].click();
            });
        }
    }
}

/*  To scape the load we create a window function that points to the main function.
    This will allow us more control, when to create the maps, etc. */

window.initLocationsMap = initLocationsMap;
// window.initLocationsMap = initLocationMap;
